module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_07@3x-4b64aef0f6bca22942a4b793cdb76417.webp";